import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "../../../components/AppToast";
import { daysOfWeek } from "../constant/FacilityListColumns";
import AddressFields from "../../../components/AddressFields";
import { countryList } from "../../../data/static";






const operationalHoursInitial = daysOfWeek.reduce((acc, day) => {
  acc[day] = { isOpen: false, open: "", close: "" };
  return acc;
}, {});

const allTimeRanges = [];
for (let i = 0; i < 24; i++) {
  const hour = i < 10 ? `0${i}` : i;
  allTimeRanges.push({ name: `${hour}:00`, value: `${hour}:00` });
}

const FactoryTypesEnum = {
  Factory: "F",
  Warehouse: "WH",
  Store: "S"
}

const FacilityOwnerEnum = {
  Internal: "INTERNAL",
  External: "EXTERNAL"
}

const CreateFacility = ({
  initialValues = {},
  onSubmit,
  submitText = "Save",
  cancelText = "",
  onCancel = () => { },
  readOnly = false,
  partners,
  isEdit

}) => {
  const [formData, setFormData] = useState({});
  const [partnersOptions, setPartnersOptions] = useState([]);
  const { tenantId } = useSelector((state) => state?.login?.userDetail);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    setTimeout(() => {
      const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      [...tooltipTriggerList].map(
        tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl)
      );
    }, 200);
  }, []);


  const roleFields = [
    { name: "Facility_Type", type: "select", required: true, label: "Facility Type", options: Object.entries(FactoryTypesEnum).map(([name, value]) => ({ name, value })) },
    { name: "Facility_Owner_Type", type: "select", required: true, label: "Owner Type", options: Object.entries(FacilityOwnerEnum).map(([name, value]) => ({ name, value })) },
    {
      name: "Facility_Owner_Id",
      label: "Facility Owner Id",
      type: "select",
      options: partnersOptions,
      required: true,
      isDisabled: true,
      value: partnersOptions?.length > 0 ? partnersOptions[0]?.value : "",
      conditional: (formData) => formData?.Facility_Owner_Type !== "",
    },
    {
      name: "Facility_ID",
      label: "Facility ID",
      required: true,
      tooltip: "Facility ID should match with the 3rd Party System for seamless integration"
    },

    { name: "Facility_Name", label: "Facility Name", required: true },
    { name: "Facility_Capacity", label: "Capacity", required: false },
    { name: "Facility_DockDetails", label: "Dock Details" },
    { name: "Facility_StorageType", label: " Storage Type" },
    { name: "Facility_OtherDetails", label: "Other Details" },
    { name: "Facility_ManagerDetails_firstName", label: "Manager First Name", required: true },
    { name: "Facility_ManagerDetails_lastName", label: "Manager Last Name", required: true },
    { name: "Facility_ManagerDetails_mobile", label: "Manager Mobile", required: true },
    { name: "Facility_ManagerDetails_email", label: "Manager Email", required: true },
    { name: "Facility_ManagerDetails_alternateMobile", label: "Manager Alternate Mobile", required: false },
  ];


  const countries = countryList; // Use the imported countryList from static.js


  const getPartnersOptions = (data) => {
    if (formData?.Facility_Owner_Type !== "EXTERNAL") {
      setPartnersOptions([{ name: tenantId?.tenant_name, value: tenantId._id }]);
      // Set Facility_Owner_Id to tenantId._id for internal case
      setFormData(prev => ({
        ...prev,
        Facility_Owner_Id: tenantId._id
      }));
    } else {
      setPartnersOptions(data || []);
    }
  }

  useEffect(() => {
    getPartnersOptions(partners);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.Facility_Owner_Type]);

  useEffect(() => {
    // Set initial values for update, or empty for create
    setFormData(prev => {
      // Map Facility_Type if needed
      let mappedFacilityType = initialValues.Facility_Type;
      if (mappedFacilityType === "Facility") mappedFacilityType = "F";
      if (mappedFacilityType === "Warehouse") mappedFacilityType = "WH";
      if (mappedFacilityType === "Store") mappedFacilityType = "S";
      // Determine owner type
      let mappedOwnerType = initialValues.Facility_Owner_Type;
      if (mappedOwnerType === FacilityOwnerEnum.Internal) mappedOwnerType = "INTERNAL";
      if (mappedOwnerType === FacilityOwnerEnum.External) mappedOwnerType = "EXTERNAL";

      // Extract address fields if present
      const address = initialValues.address || {};

      // Map Facility_OperationalDaysAndHours to operationalHours object
      let operationalHours = operationalHoursInitial;
      if (Array.isArray(initialValues.Facility_OperationalDaysAndHours)) {
        operationalHours = { ...operationalHoursInitial };
        initialValues.Facility_OperationalDaysAndHours.forEach(item => {
          // Convert dayRange to Title Case (e.g., "MONDAY" -> "Monday")
          const day =
            item.dayRange.charAt(0).toUpperCase() +
            item.dayRange.slice(1).toLowerCase();
          operationalHours[day] = {
            isOpen: true,
            open: item.timeRange?.open || "",
            close: item.timeRange?.close || ""
          };
        });
      } else if (initialValues.operationalHours) {
        operationalHours = initialValues.operationalHours;
      }


      const addressData = {
        Facility_Address_address1: initialValues.Facility_Address?.address1 || "",
        Facility_Address_address2: initialValues.Facility_Address?.address2 || "",
        Facility_Address_city: initialValues.Facility_Address?.city || "",
        Facility_Address_state: initialValues.Facility_Address?.state || "",
        Facility_Address_country: initialValues.Facility_Address?.country || "",
        Facility_Address_pincode: initialValues.Facility_Address?.pincode || "",
      };


      const managerData = {
  Facility_ManagerDetails_firstName: initialValues.Facility_ManagerDetails?.firstName || "",
  Facility_ManagerDetails_lastName: initialValues.Facility_ManagerDetails?.lastName || "",
  Facility_ManagerDetails_mobile: initialValues.Facility_ManagerContact?.mobile || "",
  Facility_ManagerDetails_email: initialValues.Facility_ManagerContact?.email || "",
  Facility_ManagerDetails_alternateMobile: initialValues.Facility_ManagerContact?.alternateMobile || "",
};

      console.log("addressData" , managerData);
      
      return {
        ...roleFields.reduce(
          (acc, field) => ({
            ...acc,
            [field.name]:
              field.name === "Facility_Type"
                ? mappedFacilityType || ""
                : field.name === "Facility_Owner_Id" && mappedOwnerType === "EXTERNAL"
                  ? initialValues.partnerId || ""
                            : initialValues[field.name] || "",
          }),
          {}
        ),
        ...managerData,
        ...addressData,
        operationalHours
      };
    });
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked, dataset } = e.target;
    if (value === "EXTERNAL" && partners.length === 0) {
      toast.error("Don't have partner. please select Internal role.");
      setFormData((prev) => ({ ...prev, [name]: "", }));
    } else if (value === "INTERNAL") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        Facility_Owner_Id: tenantId._id,
      }));
    }
    if (dataset.day) {
      setFormData((prev) => {
        const updatedDay = {
          ...prev.operationalHours[dataset.day],
          [name]: type === "checkbox" ? checked : value
        };
        // Ensure time fields are cleared if isOpen is unchecked
        if (name === "isOpen" && !checked) {
          updatedDay.open = "";
          updatedDay.close = "";
        }
        if (name === "isOpen" && checked) {
          updatedDay.open = updatedDay.open || "06:00";
          updatedDay.close = updatedDay.close || "23:00";
        }

        return {
          ...prev,
          operationalHours: {
            ...prev.operationalHours,
            [dataset.day]: updatedDay
          }
        };
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();


    const newErrors = {};


    const addressFields = ["address1", "city", "state", "pincode", "country"];
    addressFields.forEach((field) => {
      const key = `Facility_Address_${field}`;
      if (!formData[key]?.toString().trim()) {
        newErrors[key] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      }
    });

    // validate all required fields dynamically
    roleFields.forEach((field) => {
      if (field.required && !formData[field.name]?.toString().trim()) {
        newErrors[field.name] = `${field.label} is required`;
      }
    });

    // validate operational hours if needed (optional)
    // e.g., if no open days selected
    const openDays = Object.values(formData.operationalHours || {}).filter(v => v.isOpen);
    if (openDays.length === 0) {
      newErrors.operationalHours = "At least one operational day must be open";
    }

    // validate manager details
    const managerRequired = roleFields.filter(f =>
      (f.name.startsWith("Facility_ManagerDetails") || f.name.startsWith("Facility_ManagerContact")) && f.required
    );
    managerRequired.forEach(field => {
      if (!formData[field.name]?.toString().trim()) {
        newErrors[field.name] = `${field.label} is required`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill all required fields");
      return;
    }


    // Map owner type to string
    let ownerType = formData.Facility_Owner_Type;
    if (ownerType === FacilityOwnerEnum.Internal) ownerType = "INTERNAL";
    else if (ownerType === FacilityOwnerEnum.External) ownerType = "EXTERNAL";

    // Set partnerId/tenantId
    let partnerId = null;
    let t_Id = tenantId._id;
    if (ownerType === "INTERNAL") t_Id = formData.Facility_Owner_Id;
    else if (ownerType === "EXTERNAL") partnerId = formData.Facility_Owner_Id;

    // Convert operationalHours to array of objects as required
    const operationalDaysArr = Object.entries(formData.operationalHours || {}).filter(([day, val]) => val.isOpen).map(([day, val]) => ({
      dayRange: day,
      timeRange: {
        open: val.open,
        close: val.close
      }
    }));

    const payload = {
      Facility_Description: formData.Facility_Description,
      Facility_Type: formData.Facility_Type,
      Facility_Owner_Type: ownerType,
      partnerId,
      tenantId: t_Id,
      // Facility_Owner_Id removed
      Facility_ID: formData.Facility_ID,
      Facility_Name: formData.Facility_Name,
      Facility_Address: {
        address1: formData.Facility_Address_address1,
        address2: formData.Facility_Address_address2,
        city: formData.Facility_Address_city,
        state: formData.Facility_Address_state,
        pincode: formData.Facility_Address_pincode,
        country: formData.Facility_Address_country
      },
      Facility_OperationalDaysAndHours: operationalDaysArr,
      Facility_ManagerDetails: {
        firstName: formData.Facility_ManagerDetails_firstName,
        lastName: formData.Facility_ManagerDetails_lastName
      },
      Facility_ManagerContact: {
        mobile: formData.Facility_ManagerDetails_mobile,
        email: formData.Facility_ManagerDetails_email,
        alternateMobile: formData.Facility_ManagerDetails_alternateMobile
      },
      Facility_DockDetails: formData.Facility_DockDetails,
      Facility_StorageType: formData.Facility_StorageType,
      Facility_Capacity: formData.Facility_Capacity,
      Facility_Source: formData.Facility_Source,
      Facility_OtherDetails: formData.Facility_OtherDetails
    };

    onSubmit(payload);
  };

  return (

    <form onSubmit={handleSubmit}>
      <div className="mt-3 p-2">

        {/* === Main Fields (excluding manager) === */}
        <div className="row gx-3 gy-3">
          {roleFields
            .filter(field => !field.name.startsWith("Facility_ManagerDetails") && !field.name.startsWith("Facility_ManagerContact"))
            .map((field) => {
              if (field.conditional && !field.conditional(formData)) return null;


              // Fields that should be read-only when editing
              const readonlyFieldsWhenEdit = [
                "Facility_Type",
                "Facility_Owner_Type",
                "Facility_Owner_Id",
                "Facility_ID"
              ];
              const isFieldReadOnly = readOnly || (isEdit && readonlyFieldsWhenEdit.includes(field.name));

              // Special case: disable select for read-only fields
              const isSelectDisabled = field.type === "select" && isFieldReadOnly;

              return (
                <div className="col-md-3" key={field.name}> {/* 4 per row */}
             
                  <label className="form-label fw-semibold small mb-1 d-flex align-items-center gap-1">
                    {field.label}
                    {field.required && <span className="required">*</span>}

                    {/* Add info icon only if tooltip exists */}
                    {field.tooltip && (
                      <span
                        className="ms-1"
                        style={{ cursor: "pointer" }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="right"
                        title={field.tooltip}
                      >
                        ℹ️
                      </span>
                    )}
                  </label>


                  {field.type === "select" ? (
                    <select
                      className={`form-select form-select-sm ${errors[field.name] ? "is-invalid" : ""}`}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={(e) => {
                        handleChange(e);
                        setErrors((prev) => ({ ...prev, [field.name]: "" })); // clear error
                      }}
                      // disabled={(formData?.Facility_Owner_Type === "INTERNAL" && field.isDisabled) || readOnly}
                      disabled={isSelectDisabled || (formData?.Facility_Owner_Type === "INTERNAL" && field.isDisabled)}
                    >
                      <option value="">Select {field.label}</option>
                      {field.options?.map((opt, i) => (
                        <option key={i} value={opt.value}>{opt.name}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={field.type || "text"}
                      className={`form-control form-control-sm ${errors[field.name] ? "is-invalid" : ""}`}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={(e) => {
                        handleChange(e);
                        setErrors((prev) => ({ ...prev, [field.name]: "" }));
                      }}
                      readOnly={isFieldReadOnly}
                    />
                  )}
                  {errors[field.name] && (
                    <small className="text-danger">{errors[field.name]}</small>
                  )}


                </div>
              );
            })}
        </div>

        {/* === Address Section === */}

        <div className="mt-3 p-2 border-bottom pb-3 mb-3 rounded">
          <h6 className="fw-bold mb-2">Facility Address</h6>
          <AddressFields
            prefix="Facility_Address_"
            formData={formData}
            onChange={(e) => {
              handleChange(e);
              setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
            }}
            errors={errors}
            countries={countries} // pass your countries array
            requiredFields={["address1", "city", "state", "country", "pincode"]}
            readOnly={readOnly}
          />
        </div>


        {/* === Operational Days & Hours === */}

        <div className="mt-3 p-2 border-bottom pb-3 mb-3 rounded">
          <h6 className="fw-bold mb-2">Operational Days & Hours Details</h6>
          <div className="row gx-3 gy-3">
            {daysOfWeek.map((day) => (
              <div key={day} className="col-md-3">
                <div className="d-flex flex-column border rounded p-2 bg-light">
                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="isOpen"
                      data-day={day}
                      checked={formData?.operationalHours?.[day]?.isOpen || false}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label small">{day}</label>
                  </div>

                  <div className="d-flex gap-1 mt-1">
                    <input
                      type="time"
                      name="open"
                      data-day={day}
                      value={formData?.operationalHours?.[day]?.open || "06:00"} // 👈 default open time
                      onChange={handleChange}
                      disabled={!formData?.operationalHours?.[day]?.isOpen || readOnly}
                      className="form-control form-control-sm"
                    />
                    <span>-</span>
                    <input
                      type="time"
                      name="close"
                      data-day={day}
                      value={formData?.operationalHours?.[day]?.close || "23:00"} // 👈 default close time
                      onChange={handleChange}
                      disabled={!formData?.operationalHours?.[day]?.isOpen || readOnly}
                      className="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>


        {/* === Manager Details Section === */}
        <div className="mt-3 p-2 border-bottom pb-3 mb-3 rounded">
          <h6 className="fw-bold mb-2">Manager Details</h6>
          <div className="row gx-3 gy-3">
            {roleFields
              .filter(field => field.name.startsWith("Facility_ManagerDetails") || field.name.startsWith("Facility_ManagerContact"))
              .map((field) => (
                <div className="col-md-3" key={field.name}>
                  <label className="form-label fw-semibold small mb-1">
                    {field.label}
                    {field.required && <span className="required">*</span>}
                  </label>
                  <input
                    type={field.type || "text"}
                    name={field.name}
                    value={formData[field.name]}

                    className={`form-control form-control-sm ${errors[field.name] ? "is-invalid" : ""}`}
                    onChange={(e) => {
                      handleChange(e);
                      setErrors((prev) => ({ ...prev, [field.name]: "" }));
                    }}
                    disabled={readOnly}
                  />
                  {errors[field.name] && (
                    <small className="text-danger">{errors[field.name]}</small>
                  )}
                </div>
              ))}
          </div>
        </div>


        <div className="text-end mt-3 d-flex justify-content-center gap-2">
          {readOnly ? (
            <button
              type="button"
              onClick={() => onCancel({})}
              className="btn btn-secondary"
            >
              Back
            </button>
          ) : (
            <>
              {cancelText && (
                <button
                  type="button"
                  onClick={() => onCancel({})}
                  className="btn btn-secondary"
                >
                  {cancelText}
                </button>
              )}
              <button type="submit" className="btn btn-primary">
                {submitText}
              </button>
            </>
          )}
        </div>


      </div>
    </form>

  );
};

export default CreateFacility;
